import CategoryIcon from '@material-ui/icons/Category';
import {
  PageBlueprint,
  createFrontendModule,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    PageBlueprint.make({
      name: 'catalog',
      params: {
        path: '/',
        routeRef: createRouteRef({ aliasFor: 'catalog.catalogIndex' }),
        title: 'Catalog',
        icon: <CategoryIcon />,
        loader: async () =>
          import('./CustomCatalogPage').then(m => <m.CustomCatalogPage />),
      },
    }),
  ],
});
